import React from "react";
import HomeSliderAll from "../../components/HomeSlider";
import HomeGames from "../../components/HomeGames";
import HoemMobileGamesDevelop from "../../components/HomeMobileGame";
import HomeAbout from "../../components/HomeAbout";
const HomeAll = () => {
  return (
    <>
      <HomeSliderAll />
      <HomeGames />
      <HomeAbout />
      <HoemMobileGamesDevelop />
    </>
  );
};

export default HomeAll;
